import { pathJoin } from '../../../utils'

export const createApprovalCollectionRouteMap = (prefix: string) => ({
  ':id': (id = ':id') =>
    pathJoin(prefix)(id).chainMapAuto((prefix2) => ({
      overview: pathJoin(prefix2)('overview').chain,
    })),
})
